<template>
  <BasicSkeletor>
    <template #content>
      <Header @onClickLink="setActivePage" />

      <HMTTopSection>
        <TopContent />
      </HMTTopSection>

      <component v-if="detailsPage.visible" :is="detailsPage.component" />
      <OpenHouse />
      <component v-if="galleryPage.visible" :is="galleryPage.component" />

      <MultimediaSection 
        v-if="multimediaItems.length > 0"
        :items="multimediaItems"
        :itemValue="activePage"
      />

      <div v-for="page in pages" :key="page.name" :data-scroll-name="page.name">
        <component :is="page.component" />
      </div>

    </template>
    <template #footer>
      <Footer />
    </template>
  </BasicSkeletor>
</template>

<script>
  import { mapGetters } from 'vuex';

  import BasicSkeletor from '@/shared/components/Skeletor/BasicSkeletor';
  import HMTTopSection from '@/shared/components/TopSection';
  import Header from './components/Header';
  import Footer from './components/Footer';
  import TopContent from './components/TopContent';
  import OpenHouse from './components/OpenHouse';
  import MultimediaSection from './components/MultimediaSection';

  const MULTIMEDIA_PAGES = ['slideshow', 'video', 'video-slideshow', '360-tour'];

  export default {
    name: 'Modern',
    components: {
      BasicSkeletor,
      Header,
      Footer,
      TopContent,
      HMTTopSection,
      OpenHouse,
      MultimediaSection
    },
    data () {
      return {
        activePage: null
      }
    },
    computed: {
      ...mapGetters('tour', ['getPages', 'getTopSection', 'getSettings']),
      detailsPage () {
        return {
          name: 'details',
          visible: !!this.getSettings.details,
          component: () => import('./pages/Details')
        }
      },
      galleryPage () {
        return {
          name: 'gallery',
          visible: !!this.getSettings.gallery,
          component: () => import('./pages/Gallery')
        }
      },
      multimediaItems () {
        return this.getPages
          .filter(page => MULTIMEDIA_PAGES.includes(page.value))
          .filter(page => page.value !== this.getTopSection)
          .map(({ value, label, componentName }) => ({
            value,
            label,
            component: () => import(`./pages/${componentName}`)
          }));
      },
      pages () {
        return this.getPages
          .filter(page => !MULTIMEDIA_PAGES.includes(page.value) && page.value !== 'details' && page.value !== 'gallery' && page.value !== 'map' && page.value !== this.getTopSection)
          .map(item => ({
            name: item.value,
            component: () => import(`./pages/${item.componentName}`)
          }));
      }
    },
    methods: {
      setActivePage (name) {
        this.activePage = name;
      }
    },
    created () {
      const script = document.createElement('script');
      script.src = '/tailwindcss4.js'
      document.head.appendChild(script);
    }
  };
</script>

<style src="./styles/main.scss" lang="scss"></style>
